module.exports = __webpack_public_path__ + "img/serwistag.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/serwistag.png
// module id = 1280
// module chunks = 0